// SurchargeView.jsx
import { camelCaseToTitle } from 'utils/helperMethods';

import { getTextData } from './commonViews';

import React from 'react';
import PropTypes from 'prop-types';

const SurchargeView = props => {
    const { data } = props;
    const { feeConfigListMap } = data;

    return (
        <>
            <div className="checker-section-container">
                <h1 className="checker-section-title">Pricing Section Data</h1>
                <div className="form-section allow-overflow">
                    <FeeView feeConfigListMap={feeConfigListMap} />
                </div>
            </div>
        </>
    );
};

const FeeView = ({ feeConfigListMap }) => {
    return (
        <div>
            {Object.keys(feeConfigListMap).map(feeType => (
                <div key={feeType} className="table-container">
                    <h3>{feeType} Details</h3>
                    <table>
                        <thead>
                            <tr>
                                <th>{camelCaseToTitle('lowerSlab')}</th>
                                <th>{camelCaseToTitle('higherSlab')}</th>
                                <th>{camelCaseToTitle('paymentType')}</th>
                                <th>{camelCaseToTitle('transactionType')}</th>
                                <th>{camelCaseToTitle('tax')}</th>
                                <th>{camelCaseToTitle('type')}</th>
                                <th>{camelCaseToTitle('issuer')}</th>
                                <th>{camelCaseToTitle('feeFlat')}</th>
                                <th>{camelCaseToTitle('feeType')}</th>
                                <th>{camelCaseToTitle('cardType')}</th>
                                <th>{camelCaseToTitle('currency')}</th>
                                <th>{camelCaseToTitle('onUsFlag')}</th>
                                <th>{camelCaseToTitle('paySlabId')}</th>
                                <th>{camelCaseToTitle('entityType')}</th>
                                <th>{camelCaseToTitle('feePercent')}</th>
                                <th>{camelCaseToTitle('accountType')}</th>
                                <th>{camelCaseToTitle('feeCriteria')}</th>
                                <th>{camelCaseToTitle('feeEntityId')}</th>
                                <th>{camelCaseToTitle('domesticFlag')}</th>
                                <th>{camelCaseToTitle('conditionTrue')}</th>
                                <th>{camelCaseToTitle('cardCategory')}</th>
                                <th>Category</th>
                            </tr>
                        </thead>
                        <tbody>
                            {feeConfigListMap[feeType]?.map((item, index) => (
                                <tr key={index}>
                                    <td>{getTextData(item.lowerSlab)}</td>
                                    <td>{getTextData(item.higherSlab)}</td>
                                    <td>{getTextData(item.paymentType)}</td>
                                    <td>{getTextData(item.transactionType)}</td>
                                    <td>{getTextData(item.tax)}</td>
                                    <td>{getTextData(item.type)}</td>
                                    <td>{getTextData(item.issuer)}</td>
                                    <td>{getTextData(item.feeFlat)}</td>
                                    <td>{getTextData(item.feeType)}</td>
                                    <td>{getTextData(item.cardType)}</td>
                                    <td>{getTextData(item.currency)}</td>
                                    <td>{getTextData(item.onUsFlag)}</td>
                                    <td>{getTextData(item.paySlabId)}</td>
                                    <td>{getTextData(item.entityType)}</td>
                                    <td>{getTextData(item.feePercent)}</td>
                                    <td>{getTextData(item.accountType)}</td>
                                    <td>{getTextData(item.feeCriteria)}</td>
                                    <td>{getTextData(item.feeEntityId)}</td>
                                    <td>{getTextData(item.domesticFlag)}</td>
                                    <td>{getTextData(item.conditionTrue)}</td>
                                    <td>{getTextData(item.cardCategory)}</td>
                                    <td>{getTextData(item.category)}</td>
                                </tr>
                            ))}
                        </tbody>
                    </table>
                </div>
            ))}
        </div>
    );
};

SurchargeView.propTypes = {
    data: PropTypes.object,
};

FeeView.propTypes = {
    feeConfigListMap: PropTypes.object,
};

export default SurchargeView;
